import { FC } from 'react';

interface EyeSlashIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const EyeSlashIcon: FC<EyeSlashIconProps> = ({ color = 'currentColor', size = '16', className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.64594 1.64645C1.8412 1.45118 2.15778 1.45118 2.35305 1.64645L4.22455 3.51795C5.3336 2.87078 6.62386 2.5 7.99948 2.5C11.3974 2.5 14.2663 4.75919 15.1885 7.85632C15.2162 7.94938 15.2162 8.0485 15.1886 8.14157C14.739 9.65275 13.8268 10.9634 12.6168 11.9102L14.353 13.6464C14.5483 13.8417 14.5483 14.1583 14.353 14.3536C14.1578 14.5488 13.8412 14.5488 13.6459 14.3536L1.64594 2.35355C1.45068 2.15829 1.45068 1.84171 1.64594 1.64645ZM11.9036 11.197C12.9628 10.3998 13.7701 9.28683 14.1858 7.99909C13.3419 5.38785 10.8905 3.5 7.99948 3.5C6.90063 3.5 5.86644 3.7723 4.95963 4.25304L6.62085 5.91425C7.01598 5.65267 7.49017 5.5 7.99949 5.5C9.3802 5.5 10.4995 6.61929 10.4995 8C10.4995 8.50932 10.3468 8.98351 10.0852 9.37864L11.9036 11.197ZM9.3534 8.6468C9.44714 8.45099 9.49949 8.23176 9.49949 8C9.49949 7.17157 8.82792 6.5 7.99949 6.5C7.76773 6.5 7.5485 6.55235 7.35269 6.64609L9.3534 8.6468ZM2.9757 5.09998C3.18652 5.27832 3.21286 5.5938 3.03452 5.80463C2.49421 6.44336 2.07523 7.18727 1.81254 8.00091C2.65642 10.6121 5.10782 12.5 7.99889 12.5C8.61415 12.5 9.20865 12.4147 9.7716 12.2555C10.0373 12.1803 10.3136 12.3348 10.3888 12.6005C10.4639 12.8663 10.3094 13.1426 10.0437 13.2177C9.3931 13.4017 8.70706 13.5 7.99889 13.5C4.60102 13.5 1.73211 11.2408 0.809857 8.14368C0.782145 8.05062 0.782131 7.9515 0.809815 7.85843C1.10863 6.85387 1.61196 5.93793 2.27104 5.1588C2.44938 4.94797 2.76487 4.92163 2.9757 5.09998Z"
      fill={color}
    />
  </svg>
);
